<template>
  <div>
    <div v-if="!item" class="example3">
      <a-spin />
    </div>
    <fo-layout v-else>
      <div class="team-dtl">
        <p class="pr pb-10">
          <span class="pages-return-btn" @click="$router.push('/team')"><a-icon type="left" /> Back</span>
        </p>
        <a-row :gutter="20">
          <a-col :sm="12">
            <div class="card-userinfo card-shadow">
              <div class="name-photo">
                <div class="photo centerimage"
                  :style="'background-image: url(' + item.member_poster + ')'"></div>
                <div class="username">
                  <h1 class="primary to-1">{{item.member_name}}</h1>
                  <p class="black ht-30">{{item.member_title_name}}</p>
                </div>
                <div class="item-info">
                  <p class="silver">Contact</p>
                  <p class="black to-1">{{item.member_phone}}</p>
                  <p class="black to-1">{{item.member_email}}</p>
                </div>
              </div>
              <p class="info" style="white-space:pre-wrap;">{{item.member_intro}}</p>
            </div>
          </a-col>
          <a-col :sm="6">
            <div class="card-bg card-shadow">
              <div class="card-continfo">
                <!-- <div class="item-info">
                  <p class="black">Industry</p>
                  <template v-for="(industry, indusInd) in item.member_industry">
                    <p class="silver" :key="indusInd">{{industry}}</p>
                  </template>
                </div> -->
                <div class="item-info">
                  <p class="black">Practice Area</p>
                  <template v-for="(business, busInd) in item.member_business">
                    <p class="silver" :key="busInd">{{business}}</p>
                  </template>
                </div>
                <div class="item-info" v-for="(infoItem, ind) in item.member_info" :key="ind">
                  <p class="black to-1">{{infoItem.headline}}</p>
                  <p class="silver" v-for="(info, infoInd) in infoItem.mainBody" :key="infoInd">{{info.data}}</p>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :sm="6">
            <div class="card-cases card-shadow">
              <p class="title black">Performance</p>
              <fo-nodata v-if="!item.member_events || !item.member_events.length"></fo-nodata>
              <div class="case-scroll" v-else>
                <div class="btn btn-top" :class="{'btn-sele' : moveItem > 1}">
                  <a-icon type="up" @click="topHandle" />
                </div>
                <div class="scroll-bar" ref="scrollBar">
                  <ul ref="scrollContent" :style="'top:' + (-moveTop) + 'px'">
                    <li v-for="(ext, ind) in item.member_events" :key="ind" ref="zitem">{{ext.member_title}}</li>
                  </ul>
                </div>
                <div class="btn btn-bottom" :class="{'btn-sele' : moveAction}">
                  <a-icon type="down" @click="bottomHandle" />
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </fo-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      moveTop: 0, // 顶部距离
      moveItem: 1, // 移动到位置
      moveAction: true, // 可移动
      articleData: [], // 文章列表
      item: {}
    }
  },
  mounted () {
    this.readDtl()
  },
  watch: {
    '$route.params.param' () {
      this.readDtl()
    }
  },
  methods: {
    readDtl () {
      this.get({
        url: 'memberFind',
        data: {
          code: this.$route.params.param
        }
      }, (res) => {
        if (res.data.member_info) {
          res.data.member_info = JSON.parse(res.data.member_info)
        } else {
          res.data.member_info = []
        }
        if (res.data.member_events) {
          res.data.member_events = JSON.parse(res.data.member_events)
        } else {
          res.data.member_events = []
        }
        this.item = res.data
        // 加载成功第一次计算上下按钮是否可以点击
        if (this.item.member_events && this.item.member_events.length) {
          setTimeout(() => {
            this.scrollHandle()
          }, 100)
        }
      })
    },
    scrollHandle () {
      const barHeight = this.$refs.scrollBar.clientHeight
      const contHeight = this.$refs.scrollContent.clientHeight
      if (barHeight * this.moveItem >= contHeight) {
        // 已经到低了
        this.moveTop = (contHeight - barHeight)
        this.moveAction = false
      } else {
        // 可已继续移动
        this.moveTop = (barHeight * (this.moveItem - 1))
        this.moveAction = true
      }
      if (this.moveTop < 0) this.moveTop = 0
    },
    topHandle () {
      if (this.moveItem > 1) {
        this.moveItem -= 1
        this.scrollHandle()
      }
    },
    bottomHandle () {
      if (this.moveAction) {
        this.moveItem += 1
        this.scrollHandle()
      }
    }
  }
}
</script>

<style lang="less">
@import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  /* 头像宽度 */
  @photoWidth: 100px;
  /* 高度 */
  @contentHeight: 660px;
  .team-dtl {
    .card-userinfo,
    .card-continfo,
    .card-cases {
      width: 100%;
      background: #FFF;
      padding: 30px;
      margin-bottom: 20px;
    }
    .card-cases {
      height: 400px;
    }
    .card-userinfo {
      .name-photo {
        height: @photoWidth;
        padding-left: @photoWidth;
        position: relative;
        z-index: 2;
        .photo {
          width: @photoWidth;
          height: @photoWidth;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 20px;
        }
        .username{
          padding: 8px 0 0 40px;
          h1 {
            font-family: Georgia, 宋体;
            font-weight: bold;
          }
          * {
            margin: 0;
          }
        }
        .item-info {
          padding: 30px 0 0 40px;
          p:first-child {
            padding-bottom: 10px;
          }
          * {
            margin: 0;
          }
        }
      }
      .info {
        margin: 100px 0 0;
        font-size: 16px;
      }
    }
    .card-continfo {
      .item-info {
        padding-bottom: 30px;
        .black {
          font-family: Georgia, 宋体;
          font-size: 18px;
          font-weight: bold;
        }
        p:first-child {
          padding-bottom: 10px;
        }
        * {
          margin: 0;
        }
      }
      .item-info:last-child {
        padding-bottom: 0;
      }
    }
    .card-cases {
      padding-top: 70px;
      position: relative;
      .title {
        font-family: Georgia, 宋体;
        width: 100%;
        padding: 30px 30px 0;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        position: absolute;
        left: 0;
        top: 0;
      }
      .case-scroll {
        padding: 50px 0;
        height: 100%;
        position: relative;
        .btn {
          width: 100%;
          text-align: center;
          font-size: 26px;
          color: @silverlight;
          position: absolute;
          left: 0;
          i {
            cursor: pointer;
          }
        }
        .btn-top {
          top: 0;
        }
        .btn-bottom {
          bottom: 0;
        }
        .btn-sele {
          color: @primary;
        }
        .scroll-bar {
          height: 100%;
          overflow: hidden;
          position: relative;
        }
        ul {
          width: 100%;
          transition: 0.3s;
          -moz-transition: 0.3s;
          -webkit-transition: 0.3s;
          position: absolute;
          left: 0;
          li {
            padding: 20px 0;
            border-top: 1px solid @graydark;
          }
          li:last-child {
            border-bottom: 1px solid @graydark;
          }
        }
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  /* 头像宽度 */
  @photoWidth: 180px;
  /* 高度 */
  @contentHeight: 660px;
  .team-dtl {
    .card-userinfo,
    .card-continfo,
    .card-cases {
      width: 100%;
      height: @contentHeight;
      background: #FFF;
      padding: 30px;
    }
    .card-bg {
      padding-top: 30px;
      padding-bottom: 30px;
      width: 100%;
      background: #FFF;
      .card-continfo {
        padding: 0px 30px;
        height: @contentHeight - 60px;
      }
    }
    .card-userinfo {
      .name-photo {
        height: @photoWidth;
        padding-left: @photoWidth;
        position: relative;
        z-index: 2;
        .photo {
          width: @photoWidth;
          height: @photoWidth;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 0;
        }
        .username{
          padding: 8px 0 0 40px;
          h1 {
            font-family: Georgia, 宋体;
            font-weight: bold;
          }
          * {
            margin: 0;
          }
        }
        .item-info {
          padding: 30px 0 0 40px;
          p:first-child {
            padding-bottom: 10px;
          }
          * {
            margin: 0;
          }
        }
      }
      .info {
        overflow: auto;
        max-height: 400px;
        font-size: 14px;
        margin: 20px 0 0;
        padding-right: 2px;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: rgba(0,0,0,0.1);
          border-radius: 2px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.2);
          border-radius: 2px;
        }
      }
    }
    .card-continfo {
      overflow: auto;
      font-size: 14px;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: rgba(0,0,0,0.1);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.2);
        border-radius: 2px;
      }
      .item-info {
        padding-bottom: 30px;
        .black {
          font-family: Georgia, 宋体;
          font-size: 18px;
          font-weight: bold;
        }
        p:first-child {
          padding-bottom: 10px;
        }
        * {
          margin: 0;
        }
      }
      .item-info:last-child {
        padding-bottom: 0;
      }
    }
    .card-cases {
      padding-top: 70px;
      position: relative;
      .title {
        font-family: Georgia, 宋体;
        width: 100%;
        padding: 30px 30px 0;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        position: absolute;
        left: 0;
        top: 0;
      }
      .case-scroll {
        padding: 50px 0;
        height: 100%;
        position: relative;
        .btn {
          width: 100%;
          text-align: center;
          font-size: 26px;
          color: @silverlight;
          position: absolute;
          left: 0;
          i {
            cursor: pointer;
          }
        }
        .btn-top {
          top: 0;
        }
        .btn-bottom {
          bottom: 0;
        }
        .btn-sele {
          color: @primary;
        }
        .scroll-bar {
          height: 100%;
          overflow: hidden;
          position: relative;
        }
        ul {
          width: 100%;
          transition: 0.3s;
          -moz-transition: 0.3s;
          -webkit-transition: 0.3s;
          position: absolute;
          left: 0;
          li {
            padding: 20px 0;
            border-top: 1px solid @graydark;
          }
          li:last-child {
            border-bottom: 1px solid @graydark;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/teamDtl.vue